export const BUSINESS_TYPE_TAXONOMY = [
  { type: 'roofing', sic_codes: ['1761'], naics_codes: ['238160'] },
  { type: 'hvac', sic_codes: ['1711'], naics_codes: ['238220'] },
  { type: 'solar', sic_codes: ['1731'], naics_codes: ['238210'] },
  { type: 'plumbing', sic_codes: ['1711'], naics_codes: ['238220'] },
  { type: 'legal', sic_codes: ['8111'], naics_codes: ['541110'] },
  { type: 'dental', sic_codes: ['8021'], naics_codes: ['621210'] },
  { type: 'insurance', sic_codes: ['6411'], naics_codes: ['524210'] },
  { type: 'grocery store', sic_codes: ['541102', '5411'], naics_codes: ['445110'] },
  { type: 'auto repair', sic_codes: ['7538'], naics_codes: ['811111'] },
  { type: 'tax services', sic_codes: ['7291'], naics_codes: ['541213'] },
  { type: 'home security', sic_codes: ['7382'], naics_codes: ['561621'] },
  { type: 'landscaping', sic_codes: ['0782'], naics_codes: ['561730'] },
  { type: 'pest control', sic_codes: ['7342'], naics_codes: ['561710'] },
  { type: 'restoration', sic_codes: ['1521', '1799'], naics_codes: ['236118', '238990'] },
  { type: 'flooring', sic_codes: ['1752'], naics_codes: ['238330'] },
  { type: 'windows', sic_codes: ['1751'], naics_codes: ['238150'] },
  { type: 'education services', sic_codes: ['8299'], naics_codes: ['611699'] },
  { type: 'cleaning bots', sic_codes: [], naics_codes: [] },
];

const BUSINESS_TYPE_ALIASES = {
  'grocery stores': 'grocery store',
  'grocery': 'grocery store',
  'hvac services': 'hvac',
  'legal services': 'legal',
  'cleaning_bots': 'cleaning bots',
  'cleaning robots': 'cleaning bots',
};

const normalize = (value = '') => String(value).trim().toLowerCase();

const getVariants = (value = '') => {
  const normalized = normalize(value).replace(/_/g, ' ');
  const variants = new Set([normalized]);
  if (normalized.endsWith('ies')) variants.add(`${normalized.slice(0, -3)}y`);
  if (normalized.endsWith('s')) variants.add(normalized.slice(0, -1));
  return Array.from(variants).filter(Boolean);
};

export const parseCommaValues = (value = '') =>
  String(value)
    .split(',')
    .map((v) => v.trim())
    .filter(Boolean);

export const joinCommaValues = (values = []) => {
  const unique = Array.from(new Set(values.map((v) => String(v).trim()).filter(Boolean)));
  return unique.join(', ');
};

export const getBusinessTypeSuggestions = (input = '') => {
  const q = normalize(input).replace(/_/g, ' ');
  if (!q) return [];
  return BUSINESS_TYPE_TAXONOMY.filter((item) => {
    const type = normalize(item.type).replace(/_/g, ' ');
    return type.includes(q) || q.includes(type);
  });
};

export const getBusinessTypeMapping = (typeValue = '') => {
  const normalized = normalize(typeValue).replace(/_/g, ' ');
  const candidates = [normalized, BUSINESS_TYPE_ALIASES[normalized], ...getVariants(normalized)].filter(Boolean);
  return BUSINESS_TYPE_TAXONOMY.find((item) => candidates.includes(normalize(item.type).replace(/_/g, ' '))) || null;
};
